/* Spanish catalog mirroring locale-registry-control-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'control.example': 'Prepara una factura, crea un proveedor o actualiza el correo de un cliente …',
  'registry.customer': 'Clientes',
  'registry.supplier': 'Proveedores',
  'registry.product': 'Productos',
  'registry.description': 'Descripción',
  'registry.price': 'Precio unitario neto',
  'registry.type': 'Tipo',
  'registry.vat': 'Tratamiento del IVA',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Grupo de productos',
  'registry.goods': 'Mercancía',
  'registry.service': 'Servicio',
  'registry.choose': 'Elegir …',
  'registry.newDraft': 'Registro nuevo – sin guardar',
  'registry.selected': 'Seleccionado: {name}',
  'registry.archivedLabel': 'Archivado',
  'registry.matches': '{count} coincidencias. Se muestran {shown}. Afina la búsqueda si coinciden varias.',
  'registry.working': 'Trabajando en el registro …',
  'registry.review': 'Revisa los detalles en el panel del registro.',
  'registry.done.observed': 'Registro abierto y coincidencias mostradas.',
  'registry.done.opened': 'Registro abierto.',
  'registry.repeatedRead': 'La misma consulta del registro ya se completó. Revisa las coincidencias mostradas antes de continuar.',
  'registry.done.applied': 'Campos rellenados. Los cambios aún no se han guardado.',
  'registry.done.saved': 'Registro guardado.',
  'registry.done.archived': 'Registro archivado.',
  'registry.done.restored': 'El proveedor vuelve a estar activo.',
  'registry.done.unchanged': 'No hay cambios nuevos que guardar.',
  'registry.changed': 'El registro cambió después de abrirlo. Cierra el panel del registro y pídeme que lo cargue de nuevo.',
  'registry.selectFirst': 'Busca y selecciona primero el registro correcto.',
  'registry.unsupportedField': 'Este campo no se admite aquí. Usa el formulario habitual de la página.',
  'registry.unsupported': 'Usa el formulario habitual de la página para esta acción.',
  'registry.advancedProduct': 'Usa el formulario de producto habitual para cambios de IVA/tipo, suscripciones y alquileres.',
  'registry.archived': 'Este registro está archivado y no se puede editar aquí.',
  'registry.authorization': 'Describe explícitamente qué quieres guardar, archivar o restaurar.',
  'registry.country': 'Los guardados automáticos del registro admiten actualmente empresas noruegas. Usa el formulario habitual para esta empresa.',
  'registry.uncertain': 'No se confirmó el guardado. Comprueba el registro en la página antes de intentarlo de nuevo.',
  'registry.unsaved': 'El panel del registro tiene cambios sin guardar. Guárdalos o cierra primero el panel.',
  'registry.duplicate': 'Otro registro tiene el mismo nombre o número de organización. Cierra el panel y selecciona el registro existente, o usa el formulario habitual.',
});
